import { render, staticRenderFns } from "./articleManage.vue?vue&type=template&id=bdb43818&scoped=true&"
import script from "./articleManage.vue?vue&type=script&lang=js&"
export * from "./articleManage.vue?vue&type=script&lang=js&"
import style0 from "./articleManage.vue?vue&type=style&index=0&id=bdb43818&scoped=true&lang=scss&"
import style1 from "./articleManage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb43818",
  null
  
)

export default component.exports